import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import 'intersection-observer'
import IntersectionObserver from '@researchgate/react-intersection-observer'
import ClickOutside from 'react-outside-click-handler'

import DropDown from '../../assets/drop-down.svg'

import './MoreNav.css'

class MoreNav extends React.Component {
  constructor (props) {
    super(props)
    this.ref = React.createRef()
    this.state = { showMoreList: false, visibility: {} }
    this.getItem = this.getItem.bind(this)
    this.hideMoreList = this.hideMoreList.bind(this)
    this.showMoreList = this.showMoreList.bind(this)
    this.getHiddenItems = this.getHiddenItems.bind(this)
  }

  getItem ({ item, isMore }) {
    const { getItem, activeItemId, getItemId } = this.props
    return getItem({
      item,
      isMore,
      activeItemId,
      styleName: cx('link', { active: activeItemId === getItemId(item), linkNav: !isMore }),
      closeMenu: this.hideMoreList
    })
  }

  hideMoreList () {
    this.setState({ showMoreList: false })
  }

  showMoreList () {
    this.setState({ showMoreList: true })
  }

  getHiddenItems (visibility) {
    const { items, getItemId } = this.props
    return items.filter(item => !visibility[getItemId(item)])
  }

  handleIntersectionChange ({ isIntersecting }, id) {
    this.setState(({ showMoreList, visibility }) => {
      const newState = {
        showMoreList,
        visibility: {
          ...visibility,
          [id]: isIntersecting
        }
      }
      const hiddenItems = this.getHiddenItems(newState.visibility)
      if (hiddenItems.length === 0 && isIntersecting) {
        newState.showMoreList = false
      }
      return newState
    })
  }

  render () {
    const { items, activeItemId, getItemId } = this.props
    const { getItem } = this
    const { showMoreList, visibility } = this.state
    const hiddenItems = this.getHiddenItems(visibility)
    const isMoreVisible = hiddenItems.length !== 0
    const isMoreActive = isMoreVisible && hiddenItems.findIndex(item => getItemId(item) === activeItemId) !== -1
    return (
      <div styleName='root'>
        <div styleName='nav' ref={this.ref}>
          <ul data-testid='menu-nav-items' styleName='navItems'>
            {items.map(item => {
              const id = getItemId(item)
              return (
                <IntersectionObserver
                  root={this.ref.current}
                  key={id}
                  onChange={event => this.handleIntersectionChange(event, id)}
                >
                  <li data-testid='menu-nav-item' styleName='navItem'>
                    {getItem({ item, isMore: false })}
                  </li>
                </IntersectionObserver>
              )
            })}
          </ul>
        </div>
        <div styleName={cx('more', { moreHidden: !isMoreVisible })}>
          <ClickOutside onOutsideClick={this.hideMoreList}>
            <span
              title='More'
              data-testid='menu-nav-more'
              styleName={cx('moreButton', { active: isMoreActive, open: showMoreList })}
              onClick={showMoreList ? this.hideMoreList : this.showMoreList}
            >
              More <DropDown />
            </span>
            {showMoreList && (
              <ul data-testid='menu-nav-more-items' styleName='moreItems'>
                {hiddenItems.map(item => (
                  <li data-testid='menu-nav-more-item' styleName='moreItem' key={getItemId(item)}>{getItem({ item, isMore: true })}</li>
                ))}
              </ul>
            )}
          </ClickOutside>
        </div>
      </div>
    )
  }
}

// TODO: Remove default props from this Component
MoreNav.defaultProps = {
  getItemId: item => item.id,
  // eslint-disable-next-line react/prop-types
  getItem: ({ item, isMore, activeItemId, styleName, closeMenu }) => (
    <a
      href={item.href}
      title={item.title}
      styleName={styleName}
      onClick={closeMenu}
    >
      {item.title}
    </a>
  )
}

MoreNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  activeItemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  getItemId: PropTypes.func,
  getItem: PropTypes.func
}

export default MoreNav
